/* ==========================================================================
   Shestia : cœur JavaScript du thème (module SOCLE, 02/10/2026). Écrit de zéro.
   Expose window.Shestia (CONVENTIONS §5) :
     Shestia.ready(fn) ; Shestia.money(cents) -> « $159.00 AUD »
     Shestia.lock() / Shestia.unlock() : verrou du défilement (Lenis arrêté compris)
     Shestia.drawers.open(nom) / .close(nom) / .toggle(nom) sur <sh-drawer name="…">,
       événements sh:drawer:open et sh:drawer:close (detail {name}) ; clic sur le voile et focus gérés ; Échap
       comme la référence (ferme recherche, panier, vue rapide, filtres ; laisse le menu ouvert ; attributs
       no-escape / escape pour trancher)
     Shestia.cart.get() / .add(items, {sections}) / .change(key, qty) / .update(updates) ; Shestia.cart.sections ;
       événement sh:cart:updated (detail {cart, sections, action}) ; sh:cart:error (detail {message, status})
     Shestia.sections.fetch(url, sectionId) ; .fetchMany(url, ids) ; .replace(id, html, selector)
     Shestia.reveal : apparitions [data-sh-reveal="fade-up|fade|stagger|split"]
     Shestia.lenis : défilement doux (ordinateur, 768 px et plus, comme la référence) ; Shestia.reducedMotion
   Déclencheurs sans code : [data-sh-open="cart"], [data-sh-close] (ou ="nom"), [data-sh-toggle="menu"].
   ========================================================================== */
(function () {
  'use strict';

  var S = (window.Shestia = window.Shestia || {});
  var config = S.config || (S.config = {});
  var routes = config.routes || {};
  var html = document.documentElement;

  /* ---------------------------------------------------------------- outils */
  S.emit = function (name, detail, target) {
    var ev = new CustomEvent(name, { detail: detail || {}, bubbles: true, cancelable: true });
    (target || document).dispatchEvent(ev);
    return ev;
  };
  S.on = function (name, fn, target) {
    (target || document).addEventListener(name, fn);
    return function () { (target || document).removeEventListener(name, fn); };
  };
  S.debounce = function (fn, wait) {
    var t;
    return function () {
      var a = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, a); }, wait || 150);
    };
  };
  S.throttle = function (fn, wait) {
    var last = 0, t;
    return function () {
      var a = arguments, self = this, now = Date.now(), rest = (wait || 100) - (now - last);
      if (rest <= 0) { last = now; fn.apply(self, a); }
      else { clearTimeout(t); t = setTimeout(function () { last = Date.now(); fn.apply(self, a); }, rest); }
    };
  };
  S.qs = function (sel, root) { return (root || document).querySelector(sel); };
  S.qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- prêt */
  var file = [];
  var pret = false;
  S.ready = function (fn) {
    if (typeof fn !== 'function') return;
    if (pret) { try { fn(S); } catch (e) { console.error(e); } }
    else file.push(fn);
  };
  function lancerPret() {
    if (pret) return;
    pret = true;
    file.splice(0).forEach(function (fn) { try { fn(S); } catch (e) { console.error(e); } });
    S.emit('sh:ready', {});
  }

  /* ---------------------------------------------------------------- animations réduites */
  var mqReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  S.reducedMotion = mqReduit.matches;
  html.classList.toggle('sh-reduced-motion', S.reducedMotion);
  function surReduit(e) {
    S.reducedMotion = e.matches;
    html.classList.toggle('sh-reduced-motion', e.matches);
    S.emit('sh:reduced-motion', { reduced: e.matches });
  }
  if (mqReduit.addEventListener) mqReduit.addEventListener('change', surReduit);
  else if (mqReduit.addListener) mqReduit.addListener(surReduit);

  /* ---------------------------------------------------------------- argent */
  // Format de la boutique : « ${{amount}} AUD ». money(15900) -> « $159.00 AUD ».
  function grouper(n, dec, milliers, decimales) {
    if (isNaN(n) || n === null) return '0';
    var fixe = (n / 100).toFixed(dec);
    var parts = fixe.split('.');
    var entiers = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + milliers);
    return entiers + (parts[1] ? decimales + parts[1] : '');
  }
  S.money = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var f = format || config.moneyFormat || '${{amount}} AUD';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, cle) {
      switch (cle) {
        case 'amount': return grouper(cents, 2, ',', '.');
        case 'amount_no_decimals': return grouper(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return grouper(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grouper(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return grouper(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return grouper(cents, 0, ' ', '');
        case 'amount_with_space_separator': return grouper(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return grouper(cents, 2, ' ', '.');
        default: return grouper(cents, 2, ',', '.');
      }
    });
  };

  /* ---------------------------------------------------------------- défilement doux (Lenis) */
  // Référence : Lenis actif à 768 px et plus (classe « lenis » sur <html>), absent au téléphone.
  // Réglage sur la course de la molette relevée image par image jusqu'à l'arrêt (04/10, socle/queue_lenis.py, paliers de
  // 100, 720 et 1500 px à 1440 et 1024) : la référence suit la loi « durée » de Lenis avec sa courbe par défaut,
  // avancement = min(1, 1,001 - 2^(-10 t / T)), T = 2,2 s (ajusté sur le dernier pixel des trois paliers : T = 2,196 à
  // 2,199 s). Même début qu'un lissage exponentiel (50 % à ~220 ms, 90 % à ~727 ms), mais la course s'arrête net quand
  // il ne reste qu'un millième de la distance : dernier pixel à 1621, 2021 et 2100 ms. L'ancien réglage (lerp 0,053,
  // arrêt à 0,5 px du but) traînait de 42, 263 et 417 ms sur ces trois paliers (relevé d'ACCUEIL-2 : 260 ms à 720 px).
  // respectReducedMotion: false : la référence garde le défilement doux en animations réduites (relevé le 02/10 :
  // 58 px après 100 ms pour un cran de 200 px), et le PC de Naotag annonce ce réglage ; Lenis 1.3 le couperait sinon.
  S.lenisOptions = { duration: 2.2, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    wheelMultiplier: 1, smoothWheel: true, syncTouch: false, anchors: true, respectReducedMotion: false };
  S.lenis = null;
  var rafLenis = 0;
  var mqLenis = window.matchMedia('(min-width: 768px)');
  function boucleLenis(t) {
    if (!S.lenis) return;
    S.lenis.raf(t);
    rafLenis = requestAnimationFrame(boucleLenis);
  }
  // Vitesse (03/10, rapport PARCOURS) : vendor-lenis.js n'est plus chargé au téléphone, où Lenis est éteint. Le layout
  // l'appelle d'avance (preload) à 768 px et plus ; ici il est exécuté au démarrage, ou plus tard si l'écran s'élargit.
  var lenisCharge = null;
  function chargerLenis() {
    if (typeof window.Lenis === 'function' || lenisCharge || !config.lenisSrc) return;
    lenisCharge = document.createElement('script');
    lenisCharge.src = config.lenisSrc;
    lenisCharge.onload = majLenis;
    lenisCharge.onerror = function () { console.error('Shestia : Lenis introuvable'); };
    document.head.appendChild(lenisCharge);
  }
  function majLenis() {
    if (mqLenis.matches && config.smoothScroll !== false && typeof window.Lenis !== 'function') { chargerLenis(); return; }
    var veut = mqLenis.matches && typeof window.Lenis === 'function' && config.smoothScroll !== false;
    if (veut && !S.lenis) {
      try {
        S.lenis = new window.Lenis(S.lenisOptions);
        rafLenis = requestAnimationFrame(boucleLenis);
        if (verrouPose) S.lenis.stop();   // un verrou encore à poser l'arrêtera lui-même (appliquerVerrou)
        S.emit('sh:lenis', { active: true });
      } catch (e) { console.error(e); S.lenis = null; }
    } else if (!veut && S.lenis) {
      cancelAnimationFrame(rafLenis);
      S.lenis.destroy();
      S.lenis = null;
      S.emit('sh:lenis', { active: false });
    }
  }
  if (mqLenis.addEventListener) mqLenis.addEventListener('change', majLenis);
  else if (mqLenis.addListener) mqLenis.addListener(majLenis);
  S.scrollTo = function (cible, opts) {
    opts = opts || {};
    if (S.lenis) { S.lenis.scrollTo(cible, opts); return; }
    var y = typeof cible === 'number' ? cible : (cible && cible.getBoundingClientRect ? cible.getBoundingClientRect().top + window.scrollY + (opts.offset || 0) : 0);
    window.scrollTo({ top: y, behavior: opts.immediate || S.reducedMotion ? 'auto' : 'smooth' });
  };

  /* ---------------------------------------------------------------- verrou du défilement */
  // 03/10 (relevé de GLOBAL-HAUT, mesuré par socle/cout_verrou.py) : poser le verrou change la classe de <html> et le
  // débordement du body (sh-base.css) ; lenis.stop() lit alors le défilement et force un recalcul du style de TOUTE la page :
  // 17 à 29 ms sur l'accueil à 1440, 11 à 18 ms à 1024, dans le geste même, donc autant de retard au départ du
  // tiroir (et 13 à 26 ms à la fermeture). Le compteur reste immédiat (Shestia.isLocked) ; la classe sh-locked,
  // l'arrêt et la relance de Lenis et l'événement sh:lock suivent deux images plus tard, quand le panneau a déjà
  // commencé à glisser : sa courbe (0,7, 0, 0,2, 1) ne le déplace que de 1 % pendant les 100 premières ms.
  var verrous = 0, verrouPose = false, verrouPrevu = 0;
  function appliquerVerrou() {
    verrouPrevu = 0;
    var veut = verrous > 0;
    if (veut === verrouPose) return;
    verrouPose = veut;
    html.classList.toggle('sh-locked', veut);
    if (S.lenis) { if (veut) S.lenis.stop(); else S.lenis.start(); }
    S.emit('sh:lock', { locked: veut });
  }
  function prevoirVerrou() {
    if (verrouPrevu) return;
    verrouPrevu = requestAnimationFrame(function () { verrouPrevu = requestAnimationFrame(appliquerVerrou); });
  }
  S.lock = function () {
    verrous++;
    prevoirVerrou();
  };
  S.unlock = function (tout) {
    verrous = tout ? 0 : Math.max(0, verrous - 1);
    prevoirVerrou();
  };
  S.isLocked = function () { return verrous > 0; };

  /* ---------------------------------------------------------------- tiroirs */
  var FOCUSABLES = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  var pile = [];      // tiroirs ouverts, le dernier en haut
  var voile = null;

  function leVoile() {
    if (voile && document.body.contains(voile)) return voile;
    voile = document.querySelector('[data-sh-overlay]');
    if (!voile) {
      voile = document.createElement('div');
      voile.className = 'sh-overlay';
      voile.setAttribute('data-sh-overlay', '');
      voile.setAttribute('aria-hidden', 'true');
      document.body.appendChild(voile);
    }
    return voile;
  }
  function majVoile() {
    var v = leVoile();
    var haut = pile[pile.length - 1];
    var montrer = !!haut && !haut.hasAttribute('no-overlay');
    // durée et rang du voile posés AVANT la classe : lire un style calculé force le calcul, et la transition
    // partirait avec l'ancienne durée
    if (haut) {
      // un tiroir peut régler son voile (--sh-overlay-dur, --sh-overlay, --sh-overlay-blur) ; sinon voile commun relevé
      var csT = getComputedStyle(haut), csR = getComputedStyle(html);
      ['--sh-overlay-dur', '--sh-overlay', '--sh-overlay-blur', '--sh-drawer-ease'].forEach(function (p) {
        var val = csT.getPropertyValue(p).trim();
        if (val && val !== csR.getPropertyValue(p).trim()) v.style.setProperty(p, val); else v.style.removeProperty(p);
      });
      getComputedStyle(v).opacity; // calcul forcé avant le changement de classe : la transition part avec ces valeurs
      v.style.zIndex = String(54 + pile.length * 2);
    }
    // la variante du voile (attribut overlay du tiroir) reste posée pendant le fondu de fermeture : elle ne change
    // qu'à l'ouverture d'un autre tiroir (sinon le voile sauterait d'aspect en se fermant)
    if (haut) voileVariante = haut.getAttribute('overlay') || '';
    v.className = 'sh-overlay' + (montrer ? ' is-visible' : '') + (voileVariante ? ' sh-overlay--' + voileVariante : '');
  }
  var voileVariante = '';
  function majDeclencheurs(nom, ouvert) {
    S.qsa('[data-sh-open="' + nom + '"], [data-sh-toggle="' + nom + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    });
  }

  class ShDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.sh-drawer__panel') || this.firstElementChild;
      if (this.panel) {
        if (!this.panel.hasAttribute('role')) this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
        if (!this.panel.hasAttribute('tabindex')) this.panel.setAttribute('tabindex', '-1');
        this.panel.setAttribute('data-lenis-prevent', '');
        if (!this.hasAttribute('open')) this.panel.setAttribute('aria-hidden', 'true');
      }
      if (this.hasAttribute('open') && pile.indexOf(this) < 0) this.open({ silencieux: true });
    }
    disconnectedCallback() {
      var i = pile.indexOf(this);
      if (i >= 0) { pile.splice(i, 1); S.unlock(); majVoile(); }
    }
    get name() { return this.getAttribute('name') || ''; }
    get isOpen() { return this.hasAttribute('open'); }
    open(opts) {
      opts = opts || {};
      if (this.isOpen && pile.indexOf(this) >= 0) return;
      // un seul tiroir à la fois, sauf empilement demandé (attribut stack ou opts.stack)
      if (!opts.stack && !this.hasAttribute('stack')) pile.slice().forEach(function (d) { if (d !== this) d.close({ remplace: true }); }, this);
      this._retour = opts.retour || document.activeElement;
      this.setAttribute('open', '');
      if (this.panel) this.panel.removeAttribute('aria-hidden');
      pile.push(this);
      if (!this.hasAttribute('no-lock')) S.lock();
      majVoile();
      majDeclencheurs(this.name, true);
      var self = this;
      // focus après le premier rendu, pour que la transition parte de l'état fermé
      requestAnimationFrame(function () {
        var cible = self.querySelector('[autofocus]') || (self.panel && self.panel.querySelector(FOCUSABLES)) || self.panel;
        if (cible && cible.focus) { try { cible.focus({ preventScroll: true }); } catch (e) { cible.focus(); } }
      });
      if (!opts.silencieux) S.emit('sh:drawer:open', { name: this.name, drawer: this }, this);
    }
    close(opts) {
      opts = opts || {};
      var i = pile.indexOf(this);
      if (!this.isOpen && i < 0) return;
      this.removeAttribute('open');
      if (this.panel) this.panel.setAttribute('aria-hidden', 'true');
      if (i >= 0) pile.splice(i, 1);
      if (!this.hasAttribute('no-lock')) S.unlock();
      majVoile();
      majDeclencheurs(this.name, false);
      var retour = this._retour;
      this._retour = null;
      if (!opts.remplace && retour && retour.focus && document.body.contains(retour)) {
        try { retour.focus({ preventScroll: true }); } catch (e) { retour.focus(); }
      }
      S.emit('sh:drawer:close', { name: this.name, drawer: this }, this);
    }
    toggle(opts) { if (this.isOpen) this.close(opts); else this.open(opts); }
  }
  if (!customElements.get('sh-drawer')) customElements.define('sh-drawer', ShDrawer);

  function tiroir(nom) {
    return typeof nom === 'string' ? document.querySelector('sh-drawer[name="' + nom + '"]') : nom;
  }
  S.drawers = {
    get: tiroir,
    open: function (nom, opts) { var d = tiroir(nom); if (d) d.open(opts); else console.warn('Shestia : tiroir introuvable', nom); return d; },
    close: function (nom, opts) {
      if (!nom) { pile.slice().forEach(function (d) { d.close(opts); }); return null; }
      var d = tiroir(nom); if (d) d.close(opts); return d;
    },
    toggle: function (nom, opts) { var d = tiroir(nom); if (d) d.toggle(opts); return d; },
    closeAll: function () { pile.slice().forEach(function (d) { d.close(); }); },
    current: function () { return pile[pile.length - 1] || null; },
    isOpen: function (nom) { var d = tiroir(nom); return !!(d && d.isOpen); }
  };

  // Échap : exactement comme la référence, tiroir par tiroir (relevé 03/10 à 1440 et 390, tiroirs ouverts en entier,
  // outputs/shestia-theme-2026-10-02/reference/socle/echap-tiroirs.json) : la recherche, le panier, la vue rapide, les
  // filtres et le closet se ferment ; le menu reste ouvert. (Premier relevé faux pour la recherche : Échap tombait
  // pendant son ouverture de 1,8 s.) Un tiroir peut trancher lui-même : attribut no-escape (Échap ne fait rien) ou
  // escape (Échap ferme). Tab reste dans le tiroir ouvert.
  var SANS_ECHAP = { menu: 1 };
  function echapFerme(d) {
    if (d.hasAttribute('no-escape')) return false;
    if (d.hasAttribute('escape')) return true;
    return !SANS_ECHAP[d.name];
  }
  document.addEventListener('keydown', function (e) {
    var haut = pile[pile.length - 1];
    if (!haut) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (!echapFerme(haut)) return;
      e.preventDefault();
      haut.close();
      return;
    }
    if (e.key === 'Tab' && haut.panel) {
      var f = S.qsa(FOCUSABLES, haut.panel).filter(function (x) { return x.offsetParent !== null || x === document.activeElement; });
      if (!f.length) { e.preventDefault(); haut.panel.focus(); return; }
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === premier || document.activeElement === haut.panel)) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }
  });

  // Délégation : ouvrir, fermer, basculer ; clic sur le voile
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-sh-overlay]')) {
      var haut = pile[pile.length - 1];
      if (haut && !haut.hasAttribute('no-overlay-close')) haut.close();
      return;
    }
    var o = t.closest('[data-sh-open]');
    if (o) { e.preventDefault(); S.drawers.open(o.getAttribute('data-sh-open'), { retour: o }); return; }
    var b = t.closest('[data-sh-toggle]');
    if (b) { e.preventDefault(); S.drawers.toggle(b.getAttribute('data-sh-toggle'), { retour: b }); return; }
    var c = t.closest('[data-sh-close]');
    if (c) {
      var nom = c.getAttribute('data-sh-close');
      var d = nom ? tiroir(nom) : c.closest('sh-drawer');
      if (d) { e.preventDefault(); d.close(); }
    }
  });

  /* ---------------------------------------------------------------- rendu de sections */
  S.sections = {
    // HTML d'une section : GET <url>?section_id=<id>
    fetch: function (url, sectionId) {
      var u = new URL(url || window.location.href, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return fetch(u.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('Section ' + sectionId + ' : ' + r.status); return r.text(); });
    },
    // Plusieurs sections : GET <url>?sections=a,b -> {a: html, b: html}
    fetchMany: function (url, ids) {
      var u = new URL(url || window.location.href, window.location.origin);
      u.searchParams.set('sections', [].concat(ids).join(','));
      return fetch(u.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('Sections : ' + r.status); return r.json(); });
    },
    // Remplace dans la page le contenu d'une section (ou seulement d'une partie : selector) par le HTML reçu.
    // Ne remplace jamais l'élément <sh-drawer> lui-même : un tiroir ouvert le reste.
    replace: function (id, htmlTexte, selector) {
      if (htmlTexte == null) return null;
      var doc = new DOMParser().parseFromString(htmlTexte, 'text/html');
      var actuel = document.getElementById('shopify-section-' + id) || document.querySelector('[data-section-id="' + id + '"]');
      if (!actuel) return null;
      var neuf = doc.getElementById('shopify-section-' + id) || doc.body;
      if (selector) {
        var a = actuel.querySelectorAll(selector), n = neuf.querySelectorAll(selector);
        for (var i = 0; i < a.length && i < n.length; i++) a[i].innerHTML = n[i].innerHTML;
      } else {
        actuel.innerHTML = neuf === doc.body ? doc.body.innerHTML : neuf.innerHTML;
      }
      if (S.reveal) S.reveal.scan(actuel);
      S.emit('sh:section:replaced', { id: id, element: actuel }, actuel);
      return actuel;
    }
  };

  /* ---------------------------------------------------------------- panier Ajax */
  var enchainement = Promise.resolve();
  function enFile(fn) {
    var p = enchainement.then(fn, fn);
    enchainement = p.catch(function () {});
    return p;
  }
  function route(nom, defaut) {
    var r = routes[nom] || defaut;
    return r.replace(/\/$/, '');
  }
  function idsSections(opts) {
    var ids = [].concat((opts && opts.sections) || [], S.cart.sections || []);
    S.qsa('[data-sh-cart-section]').forEach(function (el) { ids.push(el.getAttribute('data-sh-cart-section')); });
    var vus = {};
    return ids.filter(function (x) { if (!x || vus[x]) return false; vus[x] = 1; return true; });
  }
  function envoyer(url, corps) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corps)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || (config.strings && config.strings.addToCartError) || 'Cart error');
          err.status = data.status || r.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }
  function echec(action) {
    return function (err) {
      S.emit('sh:cart:error', { action: action, message: err.message, status: err.status, data: err.data });
      throw err;
    };
  }
  function publier(action, cart, sections, extra) {
    S.cart.state = cart;
    var detail = { cart: cart, sections: sections || {}, action: action };
    if (extra) for (var k in extra) detail[k] = extra[k];
    S.emit('sh:cart:updated', detail);
    return detail;
  }

  S.cart = {
    sections: [],
    state: null,
    get: function () {
      return fetch(route('cart', '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { S.cart.state = cart; return cart; });
    },
    // items : {id, quantity, properties} ou une liste ; ou un <form> produit (FormData)
    add: function (items, opts) {
      opts = opts || {};
      return enFile(function () {
        var ids = idsSections(opts);
        var corps;
        if (items instanceof HTMLFormElement || items instanceof FormData) {
          var fd = items instanceof FormData ? items : new FormData(items);
          corps = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
          var props = {};
          fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props[m[1]] = v; });
          if (Object.keys(props).length) corps.items[0].properties = props;
          if (fd.get('selling_plan')) corps.items[0].selling_plan = fd.get('selling_plan');
        } else {
          corps = { items: [].concat(items).map(function (x) { return typeof x === 'object' ? x : { id: Number(x), quantity: 1 }; }) };
        }
        if (ids.length) { corps.sections = ids.join(','); corps.sections_url = window.location.pathname; }
        return envoyer(route('cartAdd', '/cart/add') + '.js', corps).then(function (ajout) {
          return S.cart.get().then(function (cart) {
            return publier('add', cart, ajout.sections, { items: ajout.items || [ajout] });
          });
        });
      }).catch(echec('add'));
    },
    // key : clé de ligne (ou identifiant de variante, ou numéro de ligne commençant à 1 via {line})
    change: function (key, quantity, opts) {
      opts = opts || {};
      return enFile(function () {
        var ids = idsSections(opts);
        var corps = typeof key === 'object' ? key : { id: String(key), quantity: Number(quantity) };
        if (typeof key !== 'object' && /^\d+$/.test(String(key)) && String(key).length < 4) corps = { line: Number(key), quantity: Number(quantity) };
        if (ids.length) { corps.sections = ids.join(','); corps.sections_url = window.location.pathname; }
        return envoyer(route('cartChange', '/cart/change') + '.js', corps).then(function (cart) {
          var sections = cart.sections; delete cart.sections;
          return publier('change', cart, sections, { key: key, quantity: quantity });
        });
      }).catch(echec('change'));
    },
    // updates : {variantId|clé: quantité} ou [quantités par ligne]
    update: function (updates, opts) {
      opts = opts || {};
      return enFile(function () {
        var ids = idsSections(opts);
        var corps = { updates: updates };
        if (opts.note != null) corps.note = opts.note;
        if (opts.attributes) corps.attributes = opts.attributes;
        if (ids.length) { corps.sections = ids.join(','); corps.sections_url = window.location.pathname; }
        return envoyer(route('cartUpdate', '/cart/update') + '.js', corps).then(function (cart) {
          var sections = cart.sections; delete cart.sections;
          return publier('update', cart, sections);
        });
      }).catch(echec('update'));
    },
    clear: function (opts) {
      opts = opts || {};
      return enFile(function () {
        var ids = idsSections(opts);
        var corps = {};
        if (ids.length) { corps.sections = ids.join(','); corps.sections_url = window.location.pathname; }
        return envoyer(route('cart', '/cart') + '/clear.js', corps).then(function (cart) {
          var sections = cart.sections; delete cart.sections;
          return publier('clear', cart, sections);
        });
      }).catch(echec('clear'));
    }
  };

  /* ---------------------------------------------------------------- apparitions au défilement */
  // [data-sh-reveal="fade-up"]  : l'élément monte de 35 px et apparaît (cartes, blocs)
  // [data-sh-reveal="fade"]     : l'élément apparaît sur place
  // [data-sh-reveal="stagger"]  : chacun de ses enfants est une carte fade-up ; celles qui entrent ensemble partent
  //                               à 100 ms d'écart (rangée de cartes)
  // [data-sh-reveal="split"]    : titre découpé mot par mot ; chaque mot apparaît en virant à --sh-accent (#D9CBB4),
  //                               s'éteint une image, puis se pose dans la couleur du titre ; 145 ms entre deux mots
  // Réglages par élément : data-sh-reveal-delay, -duration, -stagger, -y (px), -easing.
  // Valeurs relevées sur la référence (reference/socle/apparitions-normal-saut.json, -reduit-saut.json) :
  //   carte : visibilité cachée, opacité 0,01 et translateY 35 px -> visible, 1, 0 en 500 ms, ease-out (0, 0, .58, 1) ;
  //           les cartes entrées dans le même lot partent à 100 ms d'écart ;
  //   mot   : 0 -> 36 ms apparition en virant à l'accent, 36 -> 45 ms éteint, 45 -> 54 ms accent, puis couleur du titre ;
  //   animations réduites : la cascade des cartes est coupée (cartes visibles), l'éclat des titres est gardé.
  var R = S.reveal = {
    defaults: {
      'fade-up': { duration: 500, delay: 0, y: 35, from: 0.01, easing: 'cubic-bezier(0, 0, 0.58, 1)' },
      'fade': { duration: 500, delay: 0, y: 0, from: 0.01, easing: 'cubic-bezier(0, 0, 0.58, 1)' },
      'stagger': { duration: 500, delay: 0, y: 35, from: 0.01, stagger: 100, easing: 'cubic-bezier(0, 0, 0.58, 1)' },
      'split': { delay: 0, stagger: 150, word: 60 }
    },
    // Déclenchement relevé à la molette (reference/socle/seuil-apparition-*.json) : l'apparition part quand le haut de
    // l'élément passe à ~82 % de la hauteur de l'écran (81,2 à 83,7 % à 1440), sans délai ajouté ; 150 ms entre deux
    // mots (moyenne de 7 écarts sur « The first edit, made for the night ahead. » à 390 : 150,3 ms).
    batchStagger: 100,     // écart entre éléments entrés dans l'écran au même moment
    delay: 0,
    threshold: 0,
    // ligne à 86 % : l'observateur ajoute ~40 ms de latence ; le départ visible tombe alors à ~82 % comme la référence
    rootMargin: '0px 0px -14% 0px',
    observer: null
  };
  function nombre(el, nom, defaut) {
    var v = el.getAttribute('data-sh-reveal-' + nom);
    return v == null || v === '' ? defaut : parseFloat(v);
  }
  function animer(el, images, opts) {
    if (el.animate) {
      try { return el.animate(images, opts); } catch (e) { /* navigateur ancien */ }
    }
    var fin = images[images.length - 1];
    for (var k in fin) el.style[k] = fin[k];
    return null;
  }
  function decouper(el) {
    if (el.classList.contains('is-split') || el.querySelector('.sh-split-word')) return S.qsa('.sh-split-word', el);
    var mots = [];
    (function parcourir(n) {
      Array.prototype.slice.call(n.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var morceaux = c.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          morceaux.forEach(function (m) {
            if (!m) return;
            if (/^\s+$/.test(m)) { frag.appendChild(document.createTextNode(m)); return; }
            var s = document.createElement('span');
            s.className = 'sh-split-word';
            s.textContent = m;
            frag.appendChild(s);
            mots.push(s);
          });
          n.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== 'BR') {
          parcourir(c);
        }
      });
    })(el);
    if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    mots.forEach(function (m) { m.setAttribute('aria-hidden', 'true'); });
    el.classList.add('is-split');
    return mots;
  }
  // Réglages d'un élément : ceux de son conteneur « stagger » s'il en est un enfant, sinon les siens.
  function reglages(el) {
    var source = el._shConteneur || el;
    var type = el._shConteneur ? 'stagger' : (el.getAttribute('data-sh-reveal') || 'fade-up');
    var d = R.defaults[type] || R.defaults['fade-up'];
    return {
      type: type,
      duree: nombre(source, 'duration', d.duration),
      delai: nombre(source, 'delay', d.delay) + R.delay,
      y: nombre(source, 'y', d.y || 0),
      depart: d.from == null ? 0 : d.from,
      pas: nombre(source, 'stagger', d.stagger || R.batchStagger),
      mot: d.word,
      courbe: source.getAttribute('data-sh-reveal-easing') || d.easing
    };
  }
  function jouerMots(el, r) {
    var mots = decouper(el);
    var accent = getComputedStyle(html).getPropertyValue('--sh-accent').trim() || '#d9cbb4';
    el.classList.add('is-revealed');
    mots.forEach(function (m, i) {
      var couleur = getComputedStyle(m).color;
      // 0 -> 36 ms : apparition en virant à l'accent ; 36 -> 45 ms : éteint ; 45 -> 54 ms : accent ; puis couleur du titre
      var a = animer(m, [
        { opacity: 0, color: couleur, offset: 0, easing: 'cubic-bezier(0, 0, 0.58, 1)' },
        { opacity: 1, color: accent, offset: 0.6, easing: 'step-end' },
        { opacity: 0, color: accent, offset: 0.75, easing: 'step-end' },
        { opacity: 1, color: accent, offset: 0.9, easing: 'step-end' },
        { opacity: 1, color: couleur, offset: 1 }
      ], { duration: r.mot, delay: r.delai + i * r.pas, easing: 'linear', fill: 'both' });
      if (a) a.onfinish = function () { a.cancel(); };
    });
  }
  // decalage : écart dû au lot (éléments entrés ensemble)
  R.play = function (el, decalage) {
    if (!el || el.classList.contains('is-revealed')) return;
    var r = reglages(el);
    decalage = decalage || 0;
    if (config.reveal === false) {
      el.classList.add('is-revealed');      // réglage du thème « Reveal sections on scroll » décoché
      if (r.type === 'split') decouper(el);
    } else if (r.type === 'split') {
      jouerMots(el, r);
    } else if (S.reducedMotion) {
      el.classList.add('is-revealed');      // la référence coupe la cascade en animations réduites
    } else {
      // comme la référence : l'élément reste caché (visibility hidden) jusqu'à son propre départ
      var partir = function () {
        el.classList.add('is-revealed');
        var a = animer(el, [
          { opacity: r.depart, transform: 'translateY(' + r.y + 'px)' },
          { opacity: 1, transform: 'translateY(0px)' }
        ], { duration: r.duree, easing: r.courbe, fill: 'backwards' });
        if (a) a.onfinish = function () { a.cancel(); };
      };
      var attente = r.delai + decalage;
      if (attente > 0) setTimeout(partir, attente); else partir();
    }
    S.emit('sh:reveal', { element: el, type: r.type }, el);
  };
  function ordreDocument(a, b) {
    return a === b ? 0 : (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
  }
  function surEntrees(entrees) {
    // un élément déjà dépassé (au-dessus de l'écran, page rouverte plus bas ou saut d'ancre) apparaît sans attendre
    entrees.forEach(function (en) {
      if (!en.isIntersecting && en.boundingClientRect.bottom < 0) {
        R.observer.unobserve(en.target);
        if (en.target.getAttribute('data-sh-reveal') === 'split') decouper(en.target);
        en.target.classList.add('is-revealed');
      }
    });
    var lot = entrees.filter(function (en) { return en.isIntersecting; }).map(function (en) { return en.target; });
    lot.sort(ordreDocument);
    // Un rang PAR CONTENEUR « stagger » (chaque rangée, chaque carrousel part de zéro), un rang commun pour les éléments
    // isolés. Relevé d'ACCUEIL-1 du 04/10 (verif/ACCUEIL-1/releve-doigt-et-saut-2026-10-04.txt) : à l'arrivée d'un coup
    // (ancre, retour arrière), la référence lance les deux rangées de la grille ensemble (poses 639, 739, 839 et 639,
    // 739 ms à 1440) ; avec un rang commun à tout le lot, notre seconde rangée partait 300 ms après la première. À la
    // molette ou au doigt, les conteneurs entrent dans des images différentes : rien ne change.
    var rangs = new Map();
    lot.forEach(function (el) {
      R.observer.unobserve(el);
      var mots = !el._shConteneur && el.getAttribute('data-sh-reveal') === 'split';
      var pas = el._shConteneur ? reglages(el).pas : R.batchStagger;
      var cle = el._shConteneur || null;
      var rang = rangs.get(cle) || 0;
      if (!mots) rangs.set(cle, rang + 1);
      R.play(el, mots ? 0 : rang * pas);
    });
  }
  R.scan = function (racine) {
    racine = racine || document;
    var els = S.qsa('[data-sh-reveal]', racine);
    if (racine.matches && racine.matches('[data-sh-reveal]')) els.unshift(racine);
    var cibles = [];
    els.forEach(function (el) {
      if (el.getAttribute('data-sh-reveal') === 'stagger') {
        Array.prototype.slice.call(el.children).forEach(function (c) { c._shConteneur = el; if (!c.classList.contains('is-revealed')) cibles.push(c); });
      } else if (!el.classList.contains('is-revealed')) {
        if (el.getAttribute('data-sh-reveal') === 'split') decouper(el);
        cibles.push(el);
      }
    });
    if (!('IntersectionObserver' in window)) { cibles.forEach(function (el) { R.play(el); }); R.ready = true; return; }
    if (!R.observer) R.observer = new IntersectionObserver(surEntrees, { threshold: R.threshold, rootMargin: R.rootMargin });
    cibles.forEach(function (el) { R.observer.observe(el); });
    R.ready = true;
  };
  R.refresh = R.scan;
  R.reset = function (el) {
    if (!el) return;
    el.classList.remove('is-revealed');
    if (R.observer) R.observer.observe(el);
  };

  /* ---------------------------------------------------------------- retour en haut */
  // <sh-scroll-top> (layout) : visible au-delà de 9,8 % du défilement, anneau qui suit la progression, clic qui
  // remonte comme la référence (ordinateur : décroissance exponentielle de taux ~9/s, soit Lenis lerp 0,15 ;
  // téléphone : saut immédiat). Relevés : reference/socle/anneau.json, hautpage-focus.json.
  S.scrollTopOptions = { seuil: 0.098, lerp: 0.15 };
  class ShScrollTop extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.cercle = this.querySelector('circle');
      this.longueur = 0;
      if (this.cercle && this.cercle.getTotalLength) {
        try { this.longueur = this.cercle.getTotalLength(); } catch (e) { this.longueur = 150.8; }
        this.cercle.style.strokeDasharray = this.longueur + 'px';
        this.cercle.style.strokeDashoffset = this.longueur + 'px';
      }
      this._image = 0;
      this._maj = function () {
        if (self._image) return;
        self._image = requestAnimationFrame(function () { self._image = 0; self.maj(); });
      };
      window.addEventListener('scroll', this._maj, { passive: true });
      window.addEventListener('resize', this._maj, { passive: true });
      this._clic = function (e) {
        if (!e.target.closest('button')) return;
        e.preventDefault();
        // duration: 0 : sans lui, la durée de 2,2 s du défilement doux l'emporterait sur ce lerp (Lenis préfère la durée)
        if (S.lenis) S.lenis.scrollTo(0, { lerp: S.scrollTopOptions.lerp, duration: 0 });
        else window.scrollTo({ top: 0, behavior: 'auto' });
      };
      this.addEventListener('click', this._clic);
      this.maj();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._maj);
      window.removeEventListener('resize', this._maj);
    }
    maj() {
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, window.scrollY / max));
      if (this.cercle && this.longueur) this.cercle.style.strokeDashoffset = (this.longueur * (1 - p)) + 'px';
      this.classList.toggle('is-visible', p > S.scrollTopOptions.seuil);
    }
  }
  if (!customElements.get('sh-scroll-top')) customElements.define('sh-scroll-top', ShScrollTop);

  /* ---------------------------------------------------------------- feuille de Swiper arrivée */
  // vendor-swiper.css ne bloque plus le premier rendu (layout, 03/10). Si un Swiper a été créé avant qu'elle ne
  // s'applique (réseau lent), ses tailles ont été calculées sans elle : on les recalcule dès qu'elle est là.
  document.addEventListener('sh:swiper-css', function () {
    S.qsa('.swiper-initialized').forEach(function (el) {
      if (el.swiper && typeof el.swiper.update === 'function') { try { el.swiper.update(); } catch (e) { console.error(e); } }
    });
  });

  /* ---------------------------------------------------------------- éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { R.scan(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (pile.length) S.drawers.closeAll(); });

  /* ---------------------------------------------------------------- démarrage */
  function demarrer() {
    majLenis();
    R.scan(document);
    lancerPret();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
